import 'bootstrap/dist/css/bootstrap.min.css';
import './css/global.css';
import '../src/styles/fonts.css';

import { MuiThemeProvider } from '@material-ui/core/styles';
import React from 'react';
import { Provider } from 'react-redux';
import Routers from './components/Router';
import { Toaster } from 'react-hot-toast';
import store from './store';
import theme from './theme';

function App() {
  return (
    <MuiThemeProvider theme={theme}>
      <Provider store={store}>
        <Toaster
          position="top-right"
          containerStyle={{
            zIndex: 10001,
          }}
          toastOptions={{
            blank: {
              style: {
                border: '2px solid #ffffff',
                fontFamily: 'Gilroy, sans-serif',
                padding: '2px',
              },
            },
          }}
        />
        <Routers />
      </Provider>
    </MuiThemeProvider>
  );
}

export default App;
